import { render } from "./WaypointContainer.vue?vue&type=template&id=037b7888&scoped=true"
import script from "./WaypointContainer.vue?vue&type=script&lang=js"
export * from "./WaypointContainer.vue?vue&type=script&lang=js"

import "./WaypointContainer.vue?vue&type=style&index=0&id=037b7888&scoped=true&lang=css"

import exportComponent from "/home/salih/development/sayberdata-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-037b7888"]])

export default __exports__